import { useState } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import "./ForgotPass.css"; 
import Loader from "../../components/loader/loader";
import logo from "../../assets/images/RedP_LogoT.png";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();

        setLoading(true);
        setMessage("");
        setIsSuccess(false);

        try {
            const url = `${config.REACT_APP_API_URL}/auth/forgot-password`;
            const formData = new FormData();
            formData.append("email", email);

            const response = await fetch(url, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            
            if (response.ok) {
                setIsSuccess(true);
                setMessage(data.message || "Reset link sent! Check your inbox.");
            } else {
                setIsSuccess(false);
                setMessage(data.message || "Something went wrong. Please check the email.");
            }
        } catch (err) {
            setIsSuccess(false);
            setMessage("Network error. Please try again.");
        } finally {
          setLoading(false);
        }
    };

  return (
    <div className="fp-page-container">
      <div className="fp-card">
        
        {/* --- LEFT PANEL: Information --- */}
        <div className="fp-info-section">
          <img src={logo} alt="RedP Logo" className="fp-sidebar-logo" />
          
          <div className="fp-info-content">
            <h2>Account Recovery</h2>
            <p>To reset your password:</p>
            <ol className="fp-instruction-list">
               <li>Enter the email address associated with your account.</li>
               <li>We will send you a secure link to reset your password.</li>
               <li>Click the link in the email to create a new password.</li>
            </ol>
          </div>

          <Link to="/" className="fp-back-link">
            <span>←</span> Back to Sign In
          </Link>
        </div>

        {/* --- RIGHT PANEL: Form --- */}
        <div className="fp-auth-section">
          <h1>Forgot Password?</h1>
          <p className="fp-subtitle">Enter your email to get back on track.</p>

          <form className="fp-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="name@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              aria-label="Email Address"
            />
            
            <button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>

          {loading && (
             <div style={{ marginTop: '1rem' }}><Loader text="Processing..."/></div>
          )}

          {message && (
            <div className={`fp-message ${isSuccess ? "success" : "error"}`}>
                {message}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
